import { Component, OnInit, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentoTipoRequisito, EstadoDocumentoItem, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { ISolicitudVehiculoModel } from 'src/app/models/interfaces/solicitud/ISolicitudVehiculoModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { VehiculoDialogModel, VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { SolicitudVehiculoDocumentosService } from 'src/app/services/solicitud-vehiculo-documentos/solicitud-vehiculo-documentos.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { VisorPdfDialogComponent } from 'src/app/components/shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';

@Component({
  selector: 'app-registrar-vehiculo-dialog',
  templateUrl: './registrar-vehiculo-dialog.component.html',
  styleUrls: ['./registrar-vehiculo-dialog.component.css']
})
export class RegistrarVehiculoDialogComponent implements OnInit {
  displayedColumns: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'estado',
    'acciones'
  ];
  tipoSeccion: SolicitudSeccion = SolicitudSeccion.Vehiculos;
  logs: ILogModel[] = [];

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<RegistrarVehiculoDialogComponent>,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private solicitudVehiculoDocumentoService: SolicitudVehiculoDocumentosService,
    private alertDialogService: AlertDialogService,
    @Inject(MAT_DIALOG_DATA) public data: VehiculoDialogModel
  ) { }

  ngOnInit(): void {
    if (this.data.enableEdit) {
      this.displayedColumns = this.displayedColumns.filter(p => p !== 'estado');
    }
    this.data.vehiculo.comentarios = "";
    if (this.data.vehiculo.idSolicitudVehiculo) {
      this.solicitudVehiculoService.getById(this.data.vehiculo.idSolicitud, this.data.vehiculo.idSolicitudVehiculo).subscribe((result) => {
        this.logs = result.logs.filter(p => p.comentarios != "" && p.comentarios != null);
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  addItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined = this.data.vehiculo.documentos.find(p => p.idSolicitudDocumentoRequerido === newItem.idSolicitudDocumentoRequerido);
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.rutaArchivo = newItem.rutaArchivo;
      element.contieneDocumento = true;
    }
  }

  removeItem(newItem: IConfiguracionDocumentoModel) {
    let element: DocumentacionRequeridaModel | undefined =
      this.data.vehiculo.documentos.find(
        (p) =>
          p.idSolicitudDocumentoRequerido ===
          newItem.idSolicitudDocumentoRequerido
      );
    if (element) {
      element.nombreArchivo = newItem.nombreArchivo;
      element.contieneDocumento = false;
    }
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {
      let documentosObligatorios = this.data.vehiculo.documentos.filter(
        (p) =>
        (
          p.idRequisito == DocumentoTipoRequisito.TODOS &&
          (
            p.contieneDocumento == false ||
            (p.controlarFechas === true && !p.fechaVencimiento)
          )
        )
      );

      if (documentosObligatorios.length > 0) {
        this.alertDialogService.open('Debe ingresar los documentos o fechas de vencimiento obligatorios');
      } else {

        this.solicitudVehiculoService.guardar(this.data.vehiculo).subscribe((result) => {
          console.log(result);
          this.dialogRef.close(this.data);
        });
      }
    }
  }

  downloadDocumentFromService(element: DocumentacionRequeridaModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Vehiculos;
      modelVisor.idRegistro = this.data.vehiculo.idSolicitudVehiculo;
      modelVisor.idSolicitudDocumento = element.idSolicitudVehiculoDocumento;
      modelVisor.codigoSolicitud = this.data.vehiculo.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudVehiculoDocumentoService.downloadDocumento(
        this.data.vehiculo.codigoSolicitud,
        this.data.vehiculo.idSolicitudVehiculo,
        element.idSolicitudVehiculoDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
